import { Chrome, ShieldAlert } from 'lucide-react';

import { useAuth } from '@/hooks/useAuth';

import { Button } from '../ui/button';
import { DevTestLogin } from './DevTestLogin';

export function SignInScreen() {
  const { signIn, status, error } = useAuth();

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-[var(--bg-root)]">
      <div className="w-full max-w-md rounded-lg border border-[var(--border)] bg-[var(--bg-surface)] p-8 shadow-lg">
        <div className="flex flex-col items-center gap-4 mb-6">
          <div
            className="size-14 rounded-lg flex items-center justify-center font-bold text-white text-2xl"
            style={{
              background:
                'linear-gradient(135deg, var(--accent), var(--accent-cyan))',
            }}
          >
            G
          </div>
          <div className="text-center">
            <h1
              className="text-xl font-bold bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  'linear-gradient(135deg, var(--accent), var(--accent-cyan))',
              }}
            >
              GoEnHub
            </h1>
            <p className="text-sm text-[var(--text-secondary)] mt-1">
              caudesign.jp 業務統合プラットフォーム
            </p>
          </div>
        </div>

        <Button
          type="button"
          variant="primary"
          className="w-full"
          onClick={() => void signIn()}
        >
          <Chrome />
          Google でサインイン
        </Button>

        {status === 'unregistered' && error && (
          <div className="mt-4 flex items-start gap-2 rounded-sm bg-[var(--accent-red-subtle)] border border-[var(--accent-red)] p-3 text-xs text-[var(--accent-red)]">
            <ShieldAlert className="size-4 flex-shrink-0 mt-0.5" />
            <span>{error}</span>
          </div>
        )}
        {status !== 'unregistered' && error && (
          <div className="mt-4 rounded-sm bg-[var(--accent-red-subtle)] p-3 text-xs text-[var(--accent-red)]">
            {error}
          </div>
        )}

        <p className="mt-6 text-center text-[11px] text-[var(--text-muted)]">
          caudesign.jp のメンバーのみアクセス可能です
        </p>

        <DevTestLogin />
      </div>
    </div>
  );
}
